import { Component, input, InputSignal, output, OutputEmitterRef, model, ModelSignal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

export interface MenuButtonOption {
    title: string;
    value: string;
    icon?: string;
    iconColor?: string;
}

@Component({
  selector: 'app-menu-button',
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatButtonToggleGroup,
    MatIconModule,
  ],
  templateUrl: './menu-button.component.html',
  styleUrl: './menu-button.component.scss'
})
export class MenuButtonComponent {
    options: InputSignal<MenuButtonOption[]> = input.required();
    color: InputSignal<string> = input("accent");
    value: ModelSignal<MenuButtonOption> = model.required();

    onChange: OutputEmitterRef<MenuButtonOption> = output({
        alias: 'change',
    });

    onClick: OutputEmitterRef<MenuButtonOption> = output();

    onOptionSelected(option: MenuButtonOption) {
        this.value.set(option);
        this.onChange.emit(option);
    }

    actionClicked() {
        this.onClick.emit(this.value());
    }
}
